<script>
  export default {
    name: 'MobileApp',

    props: {
      app: {
        type: Object,
        required: true
      }
    }

  }
</script>

<template>
  <div>
    <footer-title>{{ $t('teamsite.app.title', { name: app.name }) }}</footer-title>
    <p>{{ $t(vehicleString('teamsite.app.body', 'teamsite.app.body_bike')) }}</p>

    <div class="row collapse">
      <div class="columns small-11 ios-app-badge">
        <a :href="app.ios_app_store_url" target="_blank">
          <img src="@/assets/apps/badge-ios.jpg" alt="">
        </a>
      </div>
      <div class="columns small-2">
        &nbsp;
      </div>
      <div class="columns small-11 android-app-badge">
        <a :href="app.google_play_store_url" target="_blank">
          <img src="@/assets/apps/badge-android.jpg" alt="">
        </a>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.row {
  max-width: rem-calc(400) !important;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileApp.vue